import { AuthState } from 'contexts/authContext';

function filterPermissions(area, section) {
  if (area === PermissionsService.enums.AREAS.Home) {
    return [{
      viewAllowed: true,
    }];
  }
  return AuthState.permissions.filter(p => (p.areaId === area && p.sectionId === section));
}

function getAllowedFlag(area, section, flagKey) {
  if (AuthState.user.isSystemUser) {
    return true;
  }
  const permissions = filterPermissions(area, section);
  if (permissions.length === 0) {
    return false;
  }
  return permissions[0][flagKey];
}

function getLevelFlag(area, section, flagKey) {
  if (AuthState.user.isSystemUser) {
    return 9;
  }
  const permissions = filterPermissions(area, section);
  if (permissions.length === 0) {
    return 0;
  }
  return permissions[0][flagKey];
}

function getViewAllowed(area, section) {
  return getAllowedFlag(area, section, 'viewAllowed');
}

function getViewLevel(area, section) {
  return getLevelFlag(area, section, 'viewLevel');
}

function getEditAllowed(area, section) {
  return getAllowedFlag(area, section, 'editAllowed');
}

function getEditLevel(area, section) {
  return getLevelFlag(area, section, 'editLevel');
}

function getAddAllowed(area, section) {
  return getAllowedFlag(area, section, 'addAllowed');
}

function getAddLevel(area, section) {
  return getLevelFlag(area, section, 'addLevel');
}

function getDeleteAllowed(area, section) {
  return getAllowedFlag(area, section, 'deleteAllowed');
}

function getDeleteLevel(area, section) {
  return getLevelFlag(area, section, 'deleteLevel');
}

function getSpecialPermissionsAllowed(area, section) {
  return getAllowedFlag(area, section, 'specialPermissionsAllowed');
}

function getSpecialPermissionsLevel(area, section) {
  return getLevelFlag(area, section, 'specialPermissionsLevel');
}

function getAreaPermissions(area) {
  return {
    isViewAllowed: getViewAllowed(area, 0),
    viewLevel: getViewLevel(area, 0),
    isEditAllowed: getEditAllowed(area, 0),
    editLevel: getEditLevel(area, 0),
    isAddAllowed: getAddAllowed(area, 0),
    addLevel: getAddLevel(area, 0),
    isDeleteAllowed: getDeleteAllowed(area, 0),
    deleteLevel: getDeleteLevel(area, 0),
    isSpecialPermissionsAllowed: getSpecialPermissionsAllowed(area, 0),
    spceialPermissionsLevel: getSpecialPermissionsLevel(area, 0),
  };
}

function getSectionPermissions(area, section) {
  return {
    isViewAllowed: getViewAllowed(area, section),
    viewLevel: getViewLevel(area, section),
    isEditAllowed: getEditAllowed(area, section),
    editLevel: getEditLevel(area, section),
    isAddAllowed: getAddAllowed(area, section),
    addLevel: getAddLevel(area, section),
    isDeleteAllowed: getDeleteAllowed(area, section),
    deleteLevel: getDeleteLevel(area, section),
    isSpecialPermissionsAllowed: getSpecialPermissionsAllowed(area, section),
    spceialPermissionsLevel: getSpecialPermissionsLevel(area, section),
  };
}

const PermissionsService = {
  enums: {
    AREAS: {
      //Areas in react
      Home: -1,
      Account: 300,
      SoftwareUpdate: 301,
      BackofficeReports: 302,
      SystemStatus: 303, //Old
      Views: 304, //Old
      Employees: 305,
      Boarding: 306, //Old
      Orders: 307,
      MenuUpdate: 308, //Old
      SiteDashboard: 309,
      Menus: 310,

      //Areas from portal
      Operation: 1,
      Common: 2,
      Reports: 3,
      MyAccount: 4,
      Alerts: 5,
      Administration: 6,
      TakeInventory: 10,
      Dashboard: 11,
      ApplicationsAndServices: 13,
      POSiMobile: 14,
      ConfigurationAndSetup: 16,
      Exceptions: 17,
      FlashReports: 18,
      StoreUserSetup: 19,
      AppSetup: 20,
      System: 21,
      Agents: 22,
      POSiConnect: 24,
      //SoftwareUpdate: 25,
      DataWarehouse: 26,
      //BackofficeReports: 31,
    },
  },
  getViewAllowed,
  getViewLevel,
  getEditAllowed,
  getEditLevel,
  getAddAllowed,
  getAddLevel,
  getDeleteAllowed,
  getDeleteLevel,
  getSpecialPermissionsAllowed,
  getSpecialPermissionsLevel,
  getAreaPermissions,
  getSectionPermissions,
};

export default PermissionsService;